export default function () {
    $(function () {
        $('.header__menutrigger').click(function () {
            $('body').toggleClass('menu-open');
        });

        $('.footer .menu-container h2').click(function () {
            $(this).parent().parent().toggleClass('open');
        });

        $('.footer .address-container h2').click(function () {
            $(this).parent().toggleClass('open');
        });

        $('.sticky-header-wrapper button').click(function () {
            $('body').toggleClass('overlay-menu-open');
            if ($('body').hasClass('overlay-menu-open')) {
                $('.sticky-header-wrapper button .text').text('Sluiten');
            } else {
                $('.sticky-header-wrapper button .text').text('Menu');
                // $(this).children('.text').text('Sluiten')
            }
        });

        $(window).resize(function() {
            if($(window).width() < 1025 && $('body').hasClass('overlay-menu-open')) {
                $('body').removeClass('overlay-menu-open')
            }
        })

        $(document).scroll(function() {
            if(window.scrollY > 0) {
                $('.header').addClass('mobile-bg');
            } else {
                $('.header').removeClass('mobile-bg');
            }
        });

        $(document).scroll(function() {
            if(window.scrollY > 60) {
                $('.header').addClass('prep-sticky-menu');
            } else {
                $('.header').removeClass('prep-sticky-menu');
            }
        });


        $(document).scroll(function() {
            if(window.scrollY > 160) {
                $('.header').addClass('sticky-menu');
            } else {
                $('.header').removeClass('sticky-menu');
            }
        });

        const options = {
            rootMargin: '0px 0px -100%',
            threshold: [0,0.1,0.2,0.3,0.4,0.5,0.6,0.7,0.8,0.9,1]
        }

        const observer = new IntersectionObserver(function (entries) {
            if(entries[0].isIntersecting && !$('body').hasClass('overlay-menu-open')) {
                $('.sticky-header-wrapper').addClass('hide');
                $('.sticky-header-wrapper').removeClass('show');

            } else {
                $('.sticky-header-wrapper').addClass('show');
                $('.sticky-header-wrapper').removeClass('hide');
            }

        }, options)
        observer.observe(document.querySelector('.header'));


        // Verberg het fixed schild zodra de footer het schild bereikt
        const shield = document.querySelector('.header .shield');
        const shieldTrigger = document.querySelector('.footer');

        if (shield && shieldTrigger) {
            const toggleShield = function () {
                const reached = shieldTrigger.getBoundingClientRect().top <= shield.getBoundingClientRect().bottom;
                $(shield).toggleClass('shield--hidden', reached);
            };

            $(document).scroll(toggleShield);
            $(window).resize(toggleShield);
            toggleShield();
        }

    });

    // SUPPORT-3393
    $('li.menu-item.has-children a').on('click', function (event) {
        // event.preventDefault(); // Prevent the default behavior of the link

        var $submenu = $(this).siblings('ul');

        // Check if the submenu is already displayed with flex
        if ($submenu.hasClass('display-flex')) {
            $submenu.removeClass('display-flex');
        } else {
            // Otherwise, add display-flex class to the submenu
            $('li.menu-item.has-children .display-flex').removeClass('display-flex');
            $submenu.addClass('display-flex');
        }
    });

   // Optionally, reset the submenu display when the menu item loses focus
   //  $('li.menu-item.has-children a').on('blur', function () {
   //      $(this).siblings('ul').removeClass('display-flex');
   //  });Ï
}
